import { Suspense, useEffect } from 'react'
import { RouterProvider } from 'react-router-dom'

import { ModalContextProvider } from '@/app/providers/ModalProvider'
import router from '@/routes/Router'
import Loading from '@/shared/components/common/Loading'
import GlobalStyles from '@/styles/globalStyles'

function App() {
  useEffect(() => {
    const userAgent = navigator.userAgent
    if (!userAgent.includes('react-hydratable')) {
      const rootElement = document.getElementById('root')
      if (rootElement) {
        rootElement.classList.add('display_root')
      }
    }
  }, [])

  return (
    <ModalContextProvider>
      <Suspense fallback={<Loading />}>
        <RouterProvider router={router} />
      </Suspense>
      <GlobalStyles />
    </ModalContextProvider>
  )
}

export default App
